module.exports = __webpack_public_path__ + "img/ic_food.486ade1d.png";